import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineTiktokIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M9.2413 19.231c1.8357 0 3.3237-1.3141 3.3237-3.3236V2c0-.5523.4477-1 1-1h1.9004c.5847 0 1.0357.5067 1.1468 1.0806.3848 1.988 2.2195 3.7279 4.3829 4.1219.5511.1004 1.0156.5425 1.0156 1.1027V9.033c0 .5523-.4492 1.0049-.9984.946-2.1043-.2253-3.8189-1.1037-4.4726-1.622v7.5504C16.5397 19.231 13.925 23 9.2413 23S2 19.231 2 15.9074c0-4.3189 4.2078-6.9677 7.4414-6.8419.4755.0185.8109.4372.8109.913v2.0303c0 .4732-.4821.8245-.9552.8245-1.851-.0682-3.3795 1.433-3.3795 3.0741 0 1.8356 1.4881 3.3236 3.3237 3.3236Z"/>
  </SvgIcon>
}

export default LineTiktokIcon
